module.exports = __webpack_public_path__ + "static/media/2.fe7cddd7.png";